import { TranslationType } from '../types';

export const zh: TranslationType = {
  common: {
    wallets: '钱包',
    dashboard: '仪表板',
    settings: '设置',
    darkMode: '深色模式',
    lightMode: '浅色模式',
    language: '语言',
    english: 'English',
    chinese: '中文',
    russian: 'Русский',
    german: 'Deutsch',
    indonesian: 'Bahasa Indonesia',
    korean: '한국어',
    japanese: '日本語',
    thai: 'ภาษาไทย',
    blog: '博客'
  },
  footer: {
    quickLinks: '快速链接',
    about: '关于我们',
    terms: '服务条款',
    privacy: '隐私政策',
    contact: '联系我们',
    copyright: '© 2025 XCH.live. 保留所有权利。',
    description: 'Chia区块链钱包的高级监控平台。获取交易的实时提醒，通过即时通知保护您的资产，并保持对冷钱包活动的控制。',
    connectWithUs: '联系我们',
    builtBy: '由Spacescan.io用❤️打造'
  },
  home: {
    hero: {
      title: '监控您的Chia冷钱包',
      subtitle: '获取XCH交易的即时电子邮件通知',
      input: {
        label: '输入主密钥（96个字符）或XCH地址',
        placeholder: '输入主密钥（96个字符）或XCH地址',
        helper: '输入您的主密钥或XCH地址以开始监控'
      },
      buttons: {
        cardprefix: '$12',
        card: '使用卡支付',
        strprefix: '50% OFF',
        str: '使用STR支付'
      }
    },
    features: {
      title: '在为时已晚之前保护您的Chia',
      subtitle: '不要等待黑客—通过24/7监控主动保护您的冷钱包',
      vault: {
        title: '启用保险库和追回功能',
        description: '使用高级保险库功能和追回保护来保护您的资产'
      },
      monitoring: {
        title: '安全监控',
        description: '无需暴露私钥即可监控您的冷钱包活动'
      },
      alerts: {
        title: '即时提醒',
        description: '接收任何交易的即时电子邮件通知'
      },
      recovery: {
        title: '追回恢复',
        description: '在追回期内从未授权交易中恢复资金'
      }
    },
    metrics: {
      title: '我们的影响力数据',
      walletsMonitored: {
        label: '已监控钱包'
      },
      alertsSent: {
        label: '已发送提醒'
      },
      transactionsAnalyzed: {
        label: '已分析交易'
      }
    },
    testimonials: {
      title: '用户评价',
      items: [
        {
          quote: 'XCH.live让我安心，因为知道我的冷钱包正在24/7被监控。即时通知是一个改变游戏规则的功能。',
          author: '陈明',
          role: 'Chia农民'
        },
        {
          quote: '设置非常简单，监控也很可靠。这正是我的Chia持有所需要的。',
          author: 'Sarah Johnson',
          role: '加密货币投资者'
        },
        {
          quote: 'Chia钱包最好的监控解决方案。电子邮件提醒很快，仪表板非常直观。',
          author: '金大卫',
          role: '区块链开发者'
        }
      ]
    }
  },
  settings: {
    title: '设置',
    subtitle: '管理您的钱包设置',
    notifications: {
      title: '通知',
      emailNotifications: '电子邮件通知',
      emailDescription: '通过电子邮件接收交易更新',
      threshold: {
        title: '交易阈值',
        description: '触发通知的最小XCH金额（最少1 XCH）'
      }
    },
    walletInfo: {
      title: '钱包信息',
      masterKey: '主密钥'
    },
    actions: {
      save: '保存更改',
      delete: '删除钱包'
    },
    messages: {
      success: '设置保存成功！',
      error: {
        generic: '更新设置失败',
        threshold: '阈值必须至少为1 XCH',
        delete: '删除钱包失败'
      },
      deleteConfirm: '您确定要删除此钱包吗？此操作无法撤消。'
    }
  },
  wallets: {
    title: '您的钱包',
    subtitle: '管理和监控您的冷钱包',
    status: {
      active: '监控活跃',
      pending: '等待付款',
      expired: '监控已过期',
      timeLeft: {
        days: '剩余{{days}}天{{hours}}小时',
        hours: '剩余{{hours}}小时{{minutes}}分钟',
        minutes: '剩余{{minutes}}分钟',
        lessThanMinute: '剩余不到1分钟'
      }
    },
    actions: {
      payWithCard: '使用卡支付',
      completeCryptoPayment: '完成加密货币支付',
      renewMonitoring: '续订监控',
      dashboard: '仪表板',
      settings: '设置',
      addFirstWallet: '添加第一个钱包',
      removeWallet: '移除钱包'
    },
    messages: {
      noWallets: '未找到钱包'
    }
  },
  dashboard: {
    title: '钱包仪表板',
    tabs: {
      events: '事件',
      addresses: '地址'
    },
    addresses: {
      totalAddresses: '总地址数：{{count}}',
      index: '索引',
      address: '地址',
      actions: '操作'
    },
    events: {
      loadMore: '加载更多',
      noEvents: '未找到事件',
      sent: '已发送',
      received: '已接收',
      spent: '已花费',
      pending: '待处理',
      failed: '失败',
      showDetails: '显示详情',
      hideDetails: '隐藏详情',
      block: '区块',
      viewOnSpacescan: '在Spacescan上查看',
      transactionHash: '交易哈希',
      nftsReceived: '已接收NFT',
      nftsSent: '已发送NFT',
      nftTransaction: 'NFT交易',
      viewNFTDetails: '查看NFT详情',
      receivedNFTs: '已接收的NFT',
      sentNFTs: '已发送的NFT'
    }
  },
  faq: {
    title: '常见问题',
    security: {
      question: '您的监控服务有多安全？',
      answer: '我们的服务采用最高安全标准运营，仅使用您的主公钥进行监控目的。您的资金保持完全安全，因为我们永远不会访问私钥或支出功能。我们实施BLS-12-381加密标准，其中私钥（32字节）和公钥（48字节）保持分离和安全。',
      learnMore: '了解更多关于Chia中的BLS密钥 →'
    },
    monitoring: {
      question: '您的交易监控频率是多少？',
      answer: '我们的系统实时监控交易，检查Chia区块链上的每个新区块。我们跟踪所有受监控地址的活动，确保对影响您钱包的任何交易立即通知。'
    },
    masterKey: {
      question: '如何找到我钱包的主公钥？',
      answer: '您可以通过Chia钱包GUI或CLI访问您的主公钥。我们准备了一个全面的视频指南来引导您完成这个过程。重要提示：永远不要分享您的私钥或助记词 - 我们的监控服务只需要主公钥。',
      videoTitle: '如何找到您的主公钥',
      learnMore: '阅读有关查找密钥的详细指南 →'
    },
    addresses: {
      question: '使用我的主密钥可以监控多少个地址？',
      answer: '我们的服务监控与您的主密钥关联的100个派生地址，为您的钱包交易活动提供全面覆盖。'
    },
    singleAddress: {
      question: '我可以监控单个地址而不是使用主密钥吗？',
      answer: '是的，我们的服务提供监控单个地址的灵活性。您可以选择跟踪单个特定地址，而不是使用主密钥监控多个地址。'
    },
    notifications: {
      question: '如何自定义我的通知设置？',
      answer: '您可以通过钱包设置完全控制您的电子邮件通知。我们的仪表板提供根据您的监控需求自定义通知首选项的选项。'
    },
    vault: {
      question: '什么是Chia保险库，它是如何工作的？',
      answer: 'Chia保险库是一个高级安全功能，为您的数字资产提供增强保护。它实施额外的安全措施，如多重签名要求或时间延迟交易。保险库将资产托管与币分开，并可能需要多个签名（m/n多重签名）来批准交易。',
      learnMore: '了解更多关于Chia保险库 →'
    },
    clawback: {
      question: 'Chia中的追回功能是什么？',
      answer: '追回是Chia中的一个安全功能，可以在指定时间范围内实现交易可逆性。启用后，接收者必须等待追回期过期才能访问转账的资金，这提供了额外的交易安全层。'
    },
    vaultSupport: {
      question: '您的服务支持保险库和追回功能吗？',
      answer: '虽然我们监控涉及保险库和追回功能的交易，但我们不直接管理这些功能。这些功能需要在钱包创建时配置。我们的服务专注于为您的地址提供交易监控和通知传递。'
    },
    tokens: {
      question: '您提供Chia代币的监控吗？',
      answer: '目前，我们的监控服务专注于XCH交易。我们当前的服务不支持代币监控功能。'
    },
    nft: {
      question: 'NFT交易监控是否可用？',
      answer: '目前，我们的服务专注于XCH交易监控。我们当前的服务功能不包括NFT交易监控。'
    },
    subscription: {
      question: '您的订阅和退款政策是什么？',
      answer: '我们的服务基于订阅提供。由于我们监控服务的即时性质，一旦服务激活，我们不提供退款。请在订阅前确保您理解我们的服务条款。'
    }
  },
  notFound: {
    title: '页面未找到',
    lostMessage: '别让您的Chia像这个页面一样 - 消失在虚空中！',
    securityMessage: '返回主页，了解如何全天候安全监控您的XCH。',
    protectButton: '保护您的Chia'
  }
}; 